define('ordersDetailOrderCommentsListCommentView',[
  'module',
  'backbone',
  'underscore',
  'settings',
  'ordersDetailOrderCommentsEditView',
  'ordersDetailOrderCommentsListCommentTagsView',
  'commentView',
  'commentsTags',
  'template!ordersDetailOrderCommentsListCommentView'
], function(
  Module,
  Backbone,
  _,
  Settings,
  EditView,
  TagsView,
  CommentView,
  Tags,
  Tpl
) {
  'use strict';

  Module.exports = CommentView.extend({    
    className: 'comment-view ' + CommentView.prototype.className,
    template: Tpl,    
    EditView: EditView,

    ui: _.extend({}, CommentView.prototype.ui, {
      tagsRegion: '.tags-region'
    }),   

    regions: _.extend({}, CommentView.prototype.regions, {
      tagsRegion: '.tags-region'
    }),
    
    onRender: function() {
      CommentView.prototype.onRender.apply(this, arguments);

      if(Settings.configValue('advancedMode') === true) {

        if (this.model.get('tags') && this.model.get('tags') !== '')
            this.ui.tagsRegion.css('display', 'flex');
        else
          this.ui.tagsRegion.hide();

        if (this.model.get('tags') && this.model.get('tags') !== '') {
          this.tagsCollection = new Backbone.Collection(); 
          _.each(this.model.get('tags').split(','), function (t) {
            var tagModel = null;
            _.each(Tags.get(), function(tag) {
              if(tag.id === t)
                tagModel = new Backbone.Model(tag);
            }, this);
            this.tagsCollection.add(tagModel);
          }, this);
          
          this.tagsView = new TagsView({
            collection: this.tagsCollection, 
            order: this.options.order
          });

          this.tagsView.on('remove', function (view) {
            var tags = this.model.get('tags').split(',');
            var tag = view.model.get('id');
            tags = _.filter(tags, function (item) {
              if(item !== tag)
                return item;
            }, this);
            this.model.set('tags', tags.join(','));
            this.options.order.updateComment(this.model).done(_.bind(function() {
              this.options.order.fetch();
            }, this));
          }, this);

          this.getRegion('tagsRegion').show(this.tagsView);
        } else {
          this.ui.tagsRegion.hide();
        }
      }      
    },

    onEdit: function () {
      this.model.set('comment', this.model.get('content'));
      
      EditView.prototype.open({
        model: this.model,
        title: _.i18n('common.comment'),
        onConfirm: _.bind(function (value, tags = []) {
          var currentUserPid = Settings.get('currentUser');
          var data = {};

          data.content = value ? value : '';
          data.msgDate = new Date().getTime();
          data.externalUserId = currentUserPid.externalId ? currentUserPid.externalId : '';
          data.title = '';
          data.user = currentUserPid.secId;        
         
          var tagsIds = [];
          _.each(tags, function (tag) {
            tagsIds.push(tag.get('id'));
          }, this);  

          data.tags = tagsIds.join(',');

          this.model.set(data);          
          
          this.options.order.updateComment(this.model).done(_.bind(function() {
            this.options.order.fetch();
          }, this));
        }, this)
      });
    }
  });   
});
